import hrDashboard from './dashboard/dashboard.json'
import hrStats from './stats/stats.json'
import hrAccreditation from './accreditation/accreditation.json'
import hrCms from './cms/cms.json'
import hrAuth from './auth/auth.json'
import hrCommon from './common/common.json'
import hrCompetition from './competition/competition.json'
import hrGeneralApplications from './general-applications/general-applications.json'
import hrLeague from './league/league.json'
import hrMatch from './match/match.json'
import hrNotification from './notification/notification.json'
import hrOrganization from './organization/organization.json'
import hrPhase from './phase/phase.json'
import hrRecreation from './recreation/recreation.json'
import hrRoles from './roles/roles.json'
import hrSeason from './season/season.json'
import hrShared from './shared/shared.json'
import hrSponsor from './sponsor/sponsor.json'
import hrSport from './sport/sport.json'
import htUnit from './unit/unit.json'
import hrUser from './user/user.json'
import hrUtils from './utils/utils.json'

export const hr = {
    dashboard: hrDashboard,
    stats: hrStats,
    competition: hrCompetition,
    common: hrCommon,
    accreditation: hrAccreditation,
    league: hrLeague,
    roles: hrRoles,
    season: hrSeason,
    sponsor: hrSponsor,
    sport: hrSport,
    user: hrUser,
    notification: hrNotification,
    unit: htUnit,
    shared: hrShared,
    organization: hrOrganization,
    'general-applications': hrGeneralApplications,
    phase: hrPhase,
    utils: hrUtils,
    auth: hrAuth,
    match: hrMatch,
    recreation: hrRecreation,
    cms: hrCms,
}
